import summaryIcon from "../../../../assets/summary.png";

import React, { useState, useContext, useEffect } from "react";
import { DollarContext } from "../../../../contexts/DollarContext";
import AddOrderSimulation from "../../../../components/AddOrderSimulation";
import usePrevisionsStore from "../../../../store/previsionsStore";
import useProductStore from "../../../../store/productStore";
import TaxesSimulations from "../../../../components/TaxesSimulations";
import { formatarValor } from "../../../../components/OrderTable";
import CostOverviewSimulation from "../../../../components/CostOverviewSimulation";
import OrderProductsTableSimulation from "../../../../components/OrderProductsTableSimulation";
import { FaMinusSquare } from "react-icons/fa";
import useContainerStore from "../../../../store/containerStore";
import plusIcon from "../../../../assets/plusIcon.png";

import api from "../../../../services/api";

const costs = [];

const forecastCosts = [];

function parseMonetaryValue(value) {
  if (typeof value === "string") {
    let sanitizedValue = value.replace("$", "").trim();

    sanitizedValue = sanitizedValue.replace(/\./g, "").replace(",", ".");

    return parseFloat(sanitizedValue) || 0;
  }

  return value || 0;
}

const Simulacao = () => {
  const [seaFreight, setSeaFreight] = useState("");
  const [landShipping, setLandShipping] = useState("");
  const [otherTaxes, setOtherTaxes] = useState("");
  const [leadTime, setLeadTime] = useState("");
  const [transitTime, setTransiteTime] = useState("");
  const [selectPrevision, setSelectedPrevision] = useState("");
  const { previsions, getAllPrevisions } = usePrevisionsStore();
  const [orderLoadItems, setOrderItens] = useState([]);
  const { products, getAllProducts } = useProductStore();
  const [orderLoad, setOrderLoad] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [cmv, setCmv] = useState(0);
  const [cifValue, setCifValue] = useState(0);
  const [name, setName] = useState("");

  const [selectedContainers, setSelectedContainers] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState("");
  const [isModalContainerOpen, setIsModalContainerOpen] = useState(false);
  const { containers, getAllContainers } = useContainerStore();
  const dollarPriceToday = useContext(DollarContext);
  const dollarInFloat = parseFloat(
    dollarPriceToday?.replace("R$", "")?.replace(",", ".")
  );

  useEffect(() => {
    getAllProducts();
    getAllPrevisions();
  }, [getAllProducts, getAllPrevisions]);

  const validateNumericInput = (e) => {
    const inputValue = e.target.value.replace(/\D/g, ""); // Remove qualquer caractere que não seja número
    return inputValue; // Retorna apenas os números
  };

  useEffect(() => {
    getAllContainers();
  }, [getAllContainers]);

  const removeContainer = (index) => {
    setSelectedContainers((prevState) =>
      prevState.filter((_, i) => i !== index)
    );
  };

  const handleContainerChange = (container) => {
    setSelectedContainer(container);
  };

  const handleAddContainer = () => {
    if (!selectedContainer) return alert("Por favor, selecione um contêiner");

    setSelectedContainers((prevState) => [...prevState, selectedContainer]);

    //setSelectedContainer(null);
  };

  const toggleDropdown = () => {
    setIsModalContainerOpen(!isModalContainerOpen);
  };

  const formatCurrency = (value, currency) => {
    if (!value) return "";
    const numberValue = Number(value) / 100; // Converte para número e divide por 100
    return numberValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: currency,
    });
  };

  const formatCurrencyInput = (e, currency = "USD") => {
    const inputValue = e.target.value.replace(/\D/g, ""); // Remove qualquer caractere que não seja número
    const formattedValue = formatCurrency(inputValue, currency);
    return formattedValue;
  };

  const handleChangeSeaFreight = (e) => {
    const formatedValue = formatCurrencyInput(e);
    setSeaFreight(formatedValue);
  };

  const handleChangeLandShipping = (e) => {
    const formatedValue = formatCurrencyInput(e, "BRL");
    setLandShipping(formatedValue);
  };

  const handleChangeOtherTaxes = (e) => {
    const formatedValue = formatCurrencyInput(e);
    setOtherTaxes(formatedValue);
  };

  const handleChangeLeadTime = (e) => {
    const formatedValueNumber = validateNumericInput(e);
    setLeadTime(formatedValueNumber);
  };

  const handleChangeTransiteTime = (e) => {
    const formatedValueNumber = validateNumericInput(e);
    setTransiteTime(formatedValueNumber);
  };

  const validateInputs = () => {
    if (
      !seaFreight ||
      !landShipping ||
      !otherTaxes ||
      !leadTime ||
      !transitTime
    ) {
      alert(
        "Por favor, preencha todos os campos antes de criar sua simulação."
      );
      return false;
    }
    return true;
  };

  const calculateBaseValue = (
    baseType,

    maritimeFreightValue,
    containerQuantity
  ) => {
    switch (baseType) {
      case "ORDERLOAD":
        return 1;
      case "FRETEMARITIMO":
        return maritimeFreightValue;
      case "CONTAINER":
        return containerQuantity;
      default:
        throw new Error(`Tipo de base inválido: ${baseType}`);
    }
  };

  const calculateTaxValue = (taxRate, taxType, baseValue) => {
    if (taxType === "PERCENTAGE") {
      return (taxRate / 100) * baseValue;
    } else if (taxType === "FIXED") {
      return taxRate * baseValue;
    } else {
      throw new Error(`Tipo de taxa inválido: ${taxType}`);
    }
  };

  const simulateOrderLoad = ({
    containers_type,
    transit_time,
    order_load_items,
    cmv_value,
    cif_value,
    another_tax_value,
    maritime_freight_value,
    land_freight_value,
  }) => {
    try {
      let totalImpostos = 0;
      let totalIcms = 0;
      let totalIi = 0;
      let totalPis = 0;
      let totalCofins = 0;
      let totalIpi = 0;

      const orderLoad = {
        maritime_freight_value,
        land_freight_value,
        another_tax_value,
        order_load_items,
        name,
      };

      const totalItemsSize = order_load_items.reduce((total, item) => {
        return total + item.quantity * item.size;
      }, 0);

      for (const orderLoadItem of order_load_items) {
        const totalItemSize = orderLoadItem.quantity * orderLoadItem.size;

        const itemPartialMaritimeFreightValue =
          (totalItemSize / totalItemsSize) * maritime_freight_value;

        const maritimeFreightCofins =
          orderLoadItem.cofins * itemPartialMaritimeFreightValue;
        const maritimeFreightIi =
          orderLoadItem.ii * itemPartialMaritimeFreightValue;
        const maritimeFreightIpi =
          orderLoadItem.ipi * itemPartialMaritimeFreightValue;
        const maritimeFreightPis =
          orderLoadItem.pis * itemPartialMaritimeFreightValue;
        const maritimeFreightIcms =
          orderLoadItem.icms * itemPartialMaritimeFreightValue;

        orderLoadItem.cofins_value_real =
          orderLoadItem.cofins * orderLoadItem.total_value;
        orderLoadItem.ii_value_real =
          orderLoadItem.ii * orderLoadItem.total_value;
        orderLoadItem.ipi_value_real =
          orderLoadItem.ipi * orderLoadItem.total_value;
        orderLoadItem.pis_value_real =
          orderLoadItem.pis * orderLoadItem.total_value;
        orderLoadItem.icms_value_real =
          orderLoadItem.icms * orderLoadItem.total_value;

        totalCofins += orderLoadItem.cofins_value_real + maritimeFreightCofins;
        totalIcms += orderLoadItem.icms_value_real + maritimeFreightIcms;
        totalIi += orderLoadItem.ii_value_real + maritimeFreightIi;
        totalPis += orderLoadItem.pis_value_real + maritimeFreightPis;
        totalIpi += orderLoadItem.ipi_value_real + maritimeFreightIpi;

        orderLoadItem.cofins_value_real += maritimeFreightCofins;
        orderLoadItem.ii_value_real += maritimeFreightIi;
        orderLoadItem.ipi_value_real += maritimeFreightIpi;
        orderLoadItem.pis_value_real += maritimeFreightPis;
        orderLoadItem.icms_value_real += maritimeFreightIcms;

        totalImpostos +=
          orderLoadItem.cofins_value_real +
          orderLoadItem.ii_value_real +
          orderLoadItem.ipi_value_real +
          orderLoadItem.pis_value_real +
          orderLoadItem.icms_value_real;
      }

      totalImpostos += another_tax_value;

      orderLoad.cofins = totalCofins;
      orderLoad.icms = totalIcms;
      orderLoad.pis = totalPis;
      orderLoad.ii = totalIi;
      orderLoad.ipi = totalIpi;
      orderLoad.total_tax_value = totalImpostos;

      const containersQuantity = containers_type.length;

      const previsionsData = previsions.find(
        (p) => p.name_previsions === selectPrevision
      );

      const afrmmTaxBase = calculateBaseValue(
        previsionsData.afrmm_tax_from,
        maritime_freight_value,
        containersQuantity
      );
      orderLoad.afrmm_tax_value = calculateTaxValue(
        previsionsData.afrmm_tax,
        previsionsData.afrmm_tax_type,
        afrmmTaxBase
      );

      const freightCollectTaxBase = calculateBaseValue(
        previsionsData.freight_collect_tax_from,
        maritime_freight_value,
        containersQuantity
      );
      orderLoad.freight_collect_value = calculateTaxValue(
        previsionsData.freight_collect_tax,
        previsionsData.freight_collect_tax_type,
        freightCollectTaxBase
      );

      const customsClearanceBase = calculateBaseValue(
        previsionsData.customs_clearance_from,
        maritime_freight_value,
        containersQuantity
      );
      orderLoad.customs_clearance_value = calculateTaxValue(
        previsionsData.customs_clearance,
        previsionsData.customs_clearance_type,
        customsClearanceBase
      );

      const otherExpensesTaxBase = calculateBaseValue(
        previsionsData.other_expenses_from,
        maritime_freight_value,
        containersQuantity
      );
      orderLoad.other_expenses = calculateTaxValue(
        previsionsData.other_expenses_tax,
        previsionsData.other_expenses_type,
        otherExpensesTaxBase
      );

      const storageTaxBase = calculateBaseValue(
        previsionsData.storage_tax_from,
        maritime_freight_value,
        containersQuantity
      );
      orderLoad.storage_value = calculateTaxValue(
        previsionsData.storage_tax,
        previsionsData.storage_tax_type,
        storageTaxBase
      );
      const otherShippingCostsTaxBase = calculateBaseValue(
        previsionsData.other_shipping_costs_tax_from,
        maritime_freight_value,
        containersQuantity
      );
      orderLoad.other_shipping_expenses_value = calculateTaxValue(
        previsionsData.other_shipping_costs_tax,
        previsionsData.other_shipping_costs_tax_type,
        otherShippingCostsTaxBase
      );

      orderLoad.logistics_value =
        orderLoad.afrmm_tax_value +
        orderLoad.freight_collect_value +
        orderLoad.customs_clearance_value +
        orderLoad.other_expenses +
        orderLoad.storage_value +
        orderLoad.other_shipping_expenses_value;

      orderLoad.cbm = order_load_items.reduce((total, item) => {
        return total + (item.size / 100) * item.quantity;
      }, 0);

      orderLoad.weight = order_load_items
        .reduce((total, item) => {
          return total + item.weight * item.quantity;
        }, 0)
        .toFixed(2);

      orderLoad.container_quantity = order_load_items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );

      orderLoad.total_target = order_load_items.reduce(
        (sum, item) => sum + parseFloat(item.target_value),
        0
      );
      orderLoad.total_unit = order_load_items.reduce(
        (sum, item) => sum + parseFloat(item.unit_value),
        0
      );

      orderLoad.prevision_name = selectPrevision;

      return orderLoad;
    } catch (error) {
      console.error("Erro ao simular Order Load:", error.message);
      return { success: false, message: error.message };
    }
  };
  const onClick = async () => {
    try {
      if (!validateInputs()) return;

      if (selectedContainers.length === 0) {
        alert("Por favor, selecione um contêiner");
      }

      const simulatedOrderLoad = simulateOrderLoad({
        containers_type: selectedContainers,
        name_previsions: selectPrevision,
        transit_time: transitTime,
        order_load_items: orderLoadItems,
        cmv_value: cmv,
        cif_value: cifValue,
        another_tax_value: sanitizeValue(otherTaxes),
        maritime_freight_value: sanitizeValue(seaFreight),
        land_freight_value: sanitizeValue(landShipping),
      });

      setOrderLoad(simulatedOrderLoad);

      setIsActive(true);
      await api.post("/simulations", simulatedOrderLoad);
    } catch (error) {
      alert(
        error.status ? "Erro ao salvar simulação" : "Erro ao fazer simulação"
      );
      console.error("erro na simulação: ", error);
    }
  };

  const sanitizeValue = (value) => {
    return parseFloat(value.replace(/[^\d,]/g, ""));
  };

  useEffect(() => {
    const cmv = orderLoadItems.reduce((total, item) => {
      return total + item.quantity * item.target_value;
    }, 0);

    setCmv(cmv);
  }, [orderLoadItems]);

  useEffect(() => {
    setCifValue(cmv + sanitizeValue(seaFreight) + sanitizeValue(otherTaxes));
  }, [cmv, seaFreight, otherTaxes]);

  useEffect(() => {
    const wait = async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    };
    wait();
    if (isActive) {
    }
  }, [orderLoad, isActive]);

  return (
    <>
      <div className="grid grid-cols-3 gap-6">
        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Nome</strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4  outline-none focus:ring focus:ring-blue-300"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">
            Frete Marítimo
          </strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4 text-right outline-none focus:ring focus:ring-blue-300"
            placeholder="$ 0,00"
            value={seaFreight}
            onChange={handleChangeSeaFreight}
          />
        </div>

        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">
            Frete Terrestre
          </strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4 text-right outline-none focus:ring focus:ring-blue-300"
            placeholder="R$ 0,00"
            value={landShipping}
            onChange={handleChangeLandShipping}
          />
        </div>
        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Outras Taxas</strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4 text-right outline-none focus:ring focus:ring-blue-300"
            placeholder="$ 0,00"
            value={otherTaxes}
            onChange={handleChangeOtherTaxes}
          />
        </div>

        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Lead Time</strong>
          <div className="flex items-center rounded-md bg-gray-200 py-2 px-4 justify-between">
            <input
              className="bg-transparent text-right outline-none w-16"
              placeholder="0"
              value={leadTime}
              onChange={handleChangeLeadTime}
            />
            <span className="text-gray-500">dias</span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Transit Time</strong>
          <div className="flex items-center rounded-md bg-gray-200 py-2 px-4 justify-between">
            <input
              className="bg-transparent text-right outline-none w-16"
              placeholder="0"
              value={transitTime}
              onChange={handleChangeTransiteTime}
            />
            <span className="text-gray-500">dias</span>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">
            Escolha a previsão{" "}
          </strong>

          <div className="rounded-md bg-lightGray text-center ">
            <select
              className="text-center outline-none bg-transparent py-2 lg:min-w-[140px] xl:min-w-[180px] 2xl:min-w-[450px]"
              value={selectPrevision}
              onChange={(e) => setSelectedPrevision(e.target.value)}
              required
            >
              <option value="" disabled>
                Selecione a previsão
              </option>
              {previsions.map((previsions, index) => (
                <option key={index} value={previsions.name_previsions}>
                  {previsions.name_previsions}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex w-[300px] h-44 flex-col rounded-md bg-lightGray ">
          <label
            className="text-gray-700 font-semibold my-2 text-center"
            htmlFor="container-input"
          >
            Adicionar Contêiner
          </label>
          <div className="flex flex-col gap-2 max-h-28 overflow-y-auto custom-scrollbar">
            {selectedContainers.map((container, index) => (
              <div className="border-2 p-2 bg-gray-300 pr-0 flex justify-between items-center">
                <p>{container}</p>
                <button
                  className="text-red-500 w-8"
                  onClick={() => removeContainer(index)}
                  type="button"
                >
                  <FaMinusSquare />
                </button>
              </div>
            ))}
          </div>
          <div className="flex flex-col flex-grow justify-end">
            <div className="relative w-full flex">
              <input
                id="container-input"
                type="text"
                className="w-[20] border-2 border-gray-400 mr-2 px-4 py-2 bg-gray-100 rounded-lg text-gray-900 cursor-pointer focus:outline-none"
                placeholder="Selecione um contêiner"
                value={selectedContainer}
                onClick={toggleDropdown}
                required
                autoComplete="off"
              />

              {/* Dropdown de opções */}
              {isModalContainerOpen && (
                <div className="absolute z-10 mt-2 flex flex-col p-2 space-y-2 bg-gray-100 rounded-lg shadow-lg w-full">
                  {containers.map((option, index) => (
                    <div
                      key={index}
                      className="flex justify-center items-center px-4 py-2 bg-gray-200 rounded-full cursor-pointer text-gray-800 hover:bg-gray-300 transition"
                      onClick={() => {
                        handleContainerChange(option.type_container);
                        toggleDropdown();
                      }}
                    >
                      {option.type_container}
                    </div>
                  ))}
                </div>
              )}
              <button
                className="flex items-center justify-center mr-4 w-6"
                onClick={handleAddContainer}
                type="button"
              >
                <img src={plusIcon} alt="Adicionar" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <AddOrderSimulation
        orderItems={orderLoadItems}
        setOrderItems={setOrderItens}
        products={products}
      />
      <button
        className="bg-primary text-white font-bold px-4 py-2 rounded-full uppercase w-1/2 h-full self-center mt-8"
        onClick={onClick}
      >
        Criar simulação
      </button>
      {isActive && (
        <>
          <div className="bg-[#F9F9F9] my-4 md:p-2 xl:p-4 flex">
            <div className="w-full text-[#2F2E41] opacity-80 flex">
              <div className="py-2 text-[#2F2E41] opacity-80 flex flex-grow">
                <div className="flex justify-center items-center xl:px-4 md:px-2">
                  <img
                    className="md:w-[40px] md:h-[50px] xl:w-[50px] xl:h-[60px] "
                    src={summaryIcon}
                    alt=""
                  />
                </div>
                <div className=" cursor-pointer">
                  <p className="md:base xl:text-2xl">Simulação do pedido</p>
                </div>
              </div>

              <div className="text-center flex justify-between items-center flex-grow ">
                <div>
                  <p className="uppercase font-bold md:text-sm xl:text-base">
                    {orderLoad.cbm}{" "}
                    <span className="text-[#FF9533] md:text-xs">CBM</span>
                  </p>
                  <div>
                    <p className="uppercase font-bold md:text-sm xl:text-base">
                      {orderLoad.weight}{" "}
                      <span className="text-[#FF9533] md:text-xs">KG</span>
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                      Quantidade
                    </p>
                  </div>
                  <div>
                    <p className="md:text-sm xl:text-base">
                      {orderLoad.container_quantity}
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                      Total Alvo
                    </p>
                  </div>
                  <div>
                    <p className="md:text-sm xl:text-base">
                      {formatarValor(orderLoad.total_target)}
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                      Total Un.
                    </p>
                  </div>
                  <div>
                    <p className="md:text-sm xl:text-base">
                      {formatarValor(orderLoad.total_unit)}
                    </p>
                  </div>
                </div>

                <div>
                  <div>
                    <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                      Total pedido
                    </p>
                  </div>
                  <div>
                    <p className="md:text-xs xl:text-base">
                      {" "}
                      {formatarValor(orderLoad.total_target)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TaxesSimulations
            cofinsFromApi={orderLoad.cofins}
            icmsFromApi={orderLoad.icms}
            iiFromApi={orderLoad.ii}
            ipipasepFromApi={orderLoad.ipi}
            pisFromApi={orderLoad.pis}
            afrmmFromApi={orderLoad.afrmm_tax_value}
            otherShippingExpenses={orderLoad.other_shipping_expenses_value}
            storageValue={orderLoad.storage_value}
            customClearanceValue={orderLoad.customs_clearance_value}
            otherExpensesValue={orderLoad.other_expenses}
            freightCollectValue={orderLoad.freight_collect_value}
            dollarInFloat={dollarInFloat}
          />
          <CostOverviewSimulation
            title={"Simulação de gastos"}
            impostos={orderLoad.total_tax_value}
            valueTotal={orderLoad.logistics_value + orderLoad.total_tax_value}
            logistica={orderLoad.logistics_value}
          />
          <OrderProductsTableSimulation
            transporte={Number(
              orderLoad.maritime_freight_value * dollarInFloat +
                orderLoad.freight_collect_value * dollarInFloat +
                orderLoad.other_shipping_expenses_value * dollarInFloat +
                orderLoad.land_freight_value
            )}
            outrosCustos={Number(
              orderLoad.afrmm_tax_value * dollarInFloat +
                orderLoad.storage_value * dollarInFloat +
                orderLoad.other_expenses * dollarInFloat +
                orderLoad.customs_clearance_value * dollarInFloat +
                orderLoad.another_tax_value * dollarInFloat
            )}
            dollarInFloat={dollarInFloat}
            orderLoadItems={orderLoad.order_load_items}
          />
        </>
      )}
    </>
  );
};

export default Simulacao;
